<template>
  <div class="topo-panelBoard">
    <div class="h-topo_pw2" style="width:300px;height:310px; background:#000000; opacity: 0.70;border-radius:4px;" v-show="see" :style="PositionXY">     
      <div class="topo-title" style="width:100%; ">
	        <i :class="['icon hero-icon '+icon+ ' '+online + ' h-topo_topwz_i']"></i>
	        <label class="topo_title_w200" style="margin: 12px 0 0 10px;" :title='devInfo.name'>{{$t('Topo.devName')}}：{{devInfo.name}}</label>
	        
        	<a  style="cursor:pointer; float: right; margin: 8px 0 0 0;"><span @click="click()" class="e-btn-icon icon hero-icon hero-icon-remove-small" style="color:#ddd;"  :title="$t('Common.close')"></span></a>
        	 
      </div>
      
      <div class="topo-alarm" >
	      	<span>{{$t('Alarm.alarm')}}:</span>     	
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot critical radius50" ></span>{{Level0AlarmCount}}</a>
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot major radius50"></span>{{Level1AlarmCount}}</a>	      		      		      	
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot minor radius50" ></span>{{Level2AlarmCount}}</a>
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot warning radius50"></span>{{Level3AlarmCount}}</a>
      </div>
      
      <div>	  
		    <div class="h-topo_content scroll" style="width:100%; height:240px; overflow-y:scroll; ">
		        <ul class="h-topo_tableheight" style="padding: 10px 2px 0 12px;">
		          <li>{{$t('Topo.devID')}}: {{devInfo.id}}</li>
		          <li>{{$t('Topo.devType')}}: {{nameKey}}</li>
		          <li v-if="seeDevAttriTrunk">
		          	{{$t('Topo.devAttriTrunk')}}: {{devInfo.softwareVersion}}
		          </li>
		          <li>{{$t('Topo.devSoftVersion')}}: {{devInfo.displaySoftwareVersion}}</li>
		          <li>
		          	 <ul v-for="(item,i) in equipmentIPList" :key="i" style="padding-left:0;">
			          	<li>{{$t('Topo.devIp')}}: {{item.ip}}</li>
					    <li>{{$t('Topo.devPort')}}: {{item.port}}</li>
			          </ul>
		          </li>
		       </ul>
	      	</div>
        	<!-- 
	        <div style="margin: 2px 0 0 248px;">
	          <button class="e-primary e-btn btn-small" @click="alarmShowOperation">{{$t('Alarm.alarm')}}</button>
	        </div> -->
      </div>
    </div>
    <!-- “告警弹窗展示” -->
 
    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
      <template v-slot:dialog-content>
        <EquipmentAlarmShowDialog ref='alarmDetailDialog'></EquipmentAlarmShowDialog>
      </template>
    </CustomDialog>
   
  </div>
</template>
<script>
import CustomDialog from "../../components/common/CustomDialog";
import EquipmentAlarmShowDialog from "../../components/topoconfig/EquipmentAlarmShowDialog";
import { EventBus } from '../../plugins/eventBus';

export default {
	name: "EquipmentInfoForm",
	components: {
    	CustomDialog,
    	EquipmentAlarmShowDialog
	},
	data() {
    	return {
				alarmDetailObj: { id: this.id},
				typeData: [],
				typeCode: "",
				nameKey: "",
				icon: "",
				online: "",
				PositionXY: "",
				devInfo: {},
				equipmentIPList: [],
				see: false,
				id: "",
				type: "",
				trunkName: "",
				seeDevAttriTrunk: false,
		      	Level0AlarmCount: 0,
				Level1AlarmCount: 0,
				Level2AlarmCount: 0,
				Level3AlarmCount: 0,
				trunkList: [],
				trunkFields: { value: "clusterId", text: "trunkName" },
				oprSetDialog: {
				element: {
		          title: this.$t("Alarm.alarm"),
		          target: "#app",
		          isClose: true,
		          refName: "oprSetDia",
		          buttonGroup: [
		            {
		              click: this.dialogHide,
		              buttonModel: { content: this.$t("Topo.cancel") }
		            }
		          ]
		        },
		        styles: {
			          width: "810px",
			          height: "760px",
			          model: true,
			          visible: false,
		        }
		      }
		    };
		},
  		props: ["equipmentInfoForm"],
		methods: {
			    panelBoardGetData() {
					 this.axios.get(`/lte/ems/topo/device/devInfoPanelDetail/${this.id}`)
					        .then(response => {
							        if (response.data.errorCode === "SUCCESS") {
							            this.devInfo = response.data.resultVal;
							            console.debug("设备",this.devInfo)
							            this.equipmentIPList = this.devInfo.equipmentIPList;
							
							        if (this.type === 10003 && null!==this.devInfo.clusterId) {
							          this.seeDevAttriTrunk = true;
							        }
					          	}
					 });
			    },	
			    getEQAlarmCount(){
		      
		      		this.Level0AlarmCount = 0;			            	 			
					this.Level1AlarmCount = 0;			            	 			
					this.Level2AlarmCount = 0;
					this.Level3AlarmCount = 0;
					
					const principal = sessionStorage.getItem('principal');
					const user = JSON.parse(principal);
					const userId = user.userId;
	    			this.axios.get(`/lte/ems/topo/equipment/findEQAlarmCount/${userId}/${this.id}`).then(response => {
				          if (response && response.data.errorCode === "SUCCESS") {
					            const result = response.data.resultVal;
					            if (result) {				            
					            	 for(var i = 0 ; i< result.length ;i++)
					            	 {
					            	 	if(result[i].level == 0)
					            	 		this.Level0AlarmCount = result[i].count ;
					            	 			
					            	 	if(result[i].level == 1)
					            	 		this.Level1AlarmCount = result[i].count ;
					            	 			
					            	 	if(result[i].level == 2)
					            	 		this.Level2AlarmCount = result[i].count ;
										
										if(result[i].level == 3)
					            	 		this.Level3AlarmCount = result[i].count ;
					            	 }
					            }
				          } 
			        });	        	
		      },   
			  click() {
			      this.see = !this.see;
			  },
	    	  alarmShowOperation() {
					      var alarmId = this.id
					      if(this.id == 1990) //-- when unms, use unms parent
					      		alarmId = 1989;
					      		
					      		
					      let ids = [alarmId];
					      this.$axios.get(`/lte/ems/topo/netElement/${alarmId}`).then(response => {
						        if (!response.data) {
						          	return;
						        }
						        if (response && response.status === 200 && response.data.errorCode === "SUCCESS") {
							          if (response.data && response.data.resultVal.length > 0) {
							          		ids = ids.concat(response.data.resultVal);
							          }
						        } 
						        else if(response.status === 401) {
						          	EventBus.$emit('toast', {type: 'error', content: this.$t('System.loginAgain')});
						        } 
						        else {
						          	EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
						        }
						        this.$refs.alarmDetailDialog.beforeMount(ids);
						        this.$refs.oprDialog.show();
					      });
		    },
			dialogHide() {
				  this.$refs.oprDialog.clear();
				  this.$refs.oprDialog.close();
			}
		},
 		mounted() {},
  		watch: {
	    	equipmentInfoForm: {
		      handler: function(newVal, oldVal) {
		      
				    this.see = newVal.seeObj;				   
				    var changed = (this.id != newVal.idObj)? true:false;
				    this.id = newVal.idObj;
				    this.type = newVal.typeObj;		
				    this.nameKey = newVal.nameKey;				    
				    this.typeCode = newVal.typeCode;
				    this.icon = newVal.icon		    
				    if(newVal.onlineObj===1){
				     	this.online='h-pm-iconOnline';
				    }       
				    else if(newVal.onlineObj===0){
				     	this.online='h-pm-iconOffline';
				    }
				    
				    this.PositionXY = newVal.PositionXY;	//-- panel position
				      
				    if(document.getElementsByClassName('h-topo_content').length > 0) //-- scroll to top  
				      	document.getElementsByClassName('h-topo_content')[0].scrollTop = 0; 
				    
				    this.seeDevAttriTrunk = false;				
				    if(changed)
				    {
				    	 //this.queryDevType(this.type);
				    	 this.panelBoardGetData();
				    	 this.getEQAlarmCount();
				    }
			  },
			  deep: true
		}
	}
};
</script>
<style>
div.topo-alarm
{
	float: left;
    width: 100%;
    padding: 0 0 0 12px;
    color: #dddddd;
}

.topo-alarm a
{
	margin: 0 10px 0 10px;
	color: #dddddd;
	cursor: pointer;
	text-decoration: underline;
}

.topo-panelBoard ul.h-topo_tableheight li
{
	margin: 0 0 4px 0;
}

.topo-alarm .radius50
{
	width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
}
.topo-title a:hover
{
	text-decoration: none;
}
</style>
